import React from "react";
export default function PassDownArrowIcon(props) {
  //Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
  return (
    <img src={"/assets/images/passDownArrow.png"} alt="better" width="15" {...props}/>
  );
}
